import faviconDeeply from 'assets/images/deeply-favicon.png'
import faviconAyahpath from 'assets/images/favicon-ayahpath.png'
import faviconBlessedpath from 'assets/images/favicon-blessedpath.png'
import faviconCardimate from 'assets/images/favicon-cardimate.png'
import faviconDancebit from 'assets/images/favicon-dancebit.png'
import faviconFamio from 'assets/images/favicon-famio.png'
import faviconFitme from 'assets/images/favicon-fitme.webp'
import faviconPiano from 'assets/images/favicon-hello-piano.png'
import faviconKarmapath from 'assets/images/favicon-karmapath.png'
import faviconLuvly from 'assets/images/favicon-luvly.png'
import faviconMeowz from 'assets/images/favicon-meowz.png'
import faviconMygrowth from 'assets/images/favicon-mygrowth.png'
import faviconNutrimate from 'assets/images/favicon-nutrimate.png'
import faviconNutriWalking from 'assets/images/favicon-nutriwalking.png'
import faviconSpilio from 'assets/images/favicon-spilio.png'
import faviconStylio from 'assets/images/favicon-stylio.png'
import faviconTestora from 'assets/images/favicon-testora.png'
import faviconUpluv from 'assets/images/favicon-upluv.png'
import faviconWoofz from 'assets/images/favicon-woofz.png'

import { AppName } from 'root-constants'

export const META_INFO = {
  [AppName.LUVLY]: { favicon: faviconLuvly, title: 'Luvly' },
  [AppName.DANCEBIT]: { favicon: faviconDancebit, title: 'Dancebit' },
  [AppName.NUTRIMATE]: { favicon: faviconNutrimate, title: 'NutriMate' },
  [AppName.NUTRI_WALKING]: {
    favicon: faviconNutriWalking,
    title: 'NutriWalking',
  },
  [AppName.FAMIO]: { favicon: faviconFamio, title: 'Famio' },
  [AppName.UPLUV]: { favicon: faviconUpluv, title: 'UpLuv' },
  [AppName.WOOFZ]: { favicon: faviconWoofz, title: 'Woofz' },
  [AppName.MEOWZ]: { favicon: faviconMeowz, title: 'Meowz' },
  [AppName.STYLIO]: { favicon: faviconStylio, title: 'Stylio' },
  [AppName.CARDIMATE]: { favicon: faviconCardimate, title: 'Cardimate' },
  [AppName.FITME]: { favicon: faviconFitme, title: 'Fitme' },
  [AppName.MYGROWTH]: { favicon: faviconMygrowth, title: 'MyGrowth' },
  [AppName.HELLO_PIANO]: { favicon: faviconPiano, title: 'Hello Piano' },
  [AppName.AYAHPATH]: { favicon: faviconAyahpath, title: 'AyahPath' },
  [AppName.KARMAPATH]: { favicon: faviconKarmapath, title: 'KarmaPath' },
  [AppName.TESTORA]: { favicon: faviconTestora, title: 'Testora' },
  [AppName.BLESSEDPATH]: { favicon: faviconBlessedpath, title: 'BlessedPath' },
  [AppName.SPILIO]: { favicon: faviconSpilio, title: 'Spilio' },
  [AppName.DEEPLY]: { favicon: faviconDeeply, title: 'Deeply' },
}
